// One JSON file per area of the quiz, merged into the single i18next
// "translation" namespace: key "quiz.goals.title" lives in locales/<lng>/quiz.json
// under goals.title. A regional variant (es-MX, es-US) would add a folder with
// only the keys it overrides and fall back to "es".
import enAccount from "../locales/en/account.json";
import enBridge from "../locales/en/bridge.json";
import enCheckout from "../locales/en/checkout.json";
import enCommon from "../locales/en/common.json";
import enPricing from "../locales/en/pricing.json";
import enQuiz from "../locales/en/quiz.json";
import enResults from "../locales/en/results.json";
import enSplash from "../locales/en/splash.json";
import esAccount from "../locales/es/account.json";
import esBridge from "../locales/es/bridge.json";
import esCheckout from "../locales/es/checkout.json";
import esCommon from "../locales/es/common.json";
import esPricing from "../locales/es/pricing.json";
import esQuiz from "../locales/es/quiz.json";
import esResults from "../locales/es/results.json";
import esSplash from "../locales/es/splash.json";

export const resources = {
  en: {
    translation: {
      account: enAccount,
      bridge: enBridge,
      checkout: enCheckout,
      common: enCommon,
      pricing: enPricing,
      quiz: enQuiz,
      results: enResults,
      splash: enSplash,
    },
  },
  es: {
    translation: {
      account: esAccount,
      bridge: esBridge,
      checkout: esCheckout,
      common: esCommon,
      pricing: esPricing,
      quiz: esQuiz,
      results: esResults,
      splash: esSplash,
    },
  },
};
